<div class="main-content table-page table-page--compact table-page--dense horarios-editor-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>{{ horarioId ? "Editar horario" : "Alta de horario" }}</h1>
        <p>Jornada semanal, minutos objetivo y bloques de comida por día.</p>
      </div>
      <div class="table-page__toolbar-actions">
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="regresar()">
          <span class="material-icons">arrow_back</span>
          Regresar
        </button>
        <button type="button" mat-raised-button class="btn table-page__primary-btn" [disabled]="saving" (click)="guardar()">
          <span class="material-icons">save</span>
          {{ saving ? "Guardando..." : "Guardar horario" }}
        </button>
      </div>
    </section>

    <form [formGroup]="form" class="row horarios-editor-page__layout">
      <div class="col-12 col-lg-4">
        <section class="table-page__card horarios-editor-page__card">
          <h2 class="horarios-editor-page__section-title">Datos generales</h2>
          <div class="horarios-editor-page__stack">
            <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
              <mat-label>Nombre</mat-label>
              <input matInput formControlName="nombre" aria-label="Nombre" />
              <mat-error *ngIf="isFieldInvalid(form.get('nombre'))">Capture un nombre válido.</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
              <mat-label>Descripción</mat-label>
              <textarea matInput rows="4" formControlName="descripcion" aria-label="Descripción"></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
              <mat-label>Minutos de tolerancia</mat-label>
              <!-- type="text" a propósito: con type="number", lo que el navegador
                   no entiende ("10min", "diez", "-") llega al control como vacío
                   y la tolerancia se borraba sin avisar. Así el texto tal cual
                   llega al validador, que ya rechaza texto y decimales. -->
              <input matInput type="text" inputmode="numeric" autocomplete="off" aria-label="Minutos de tolerancia"
                     formControlName="minutosTolerancia" />
              <span matTextSuffix>min</span>
              <mat-hint>Opcional, de 0 a 240. Vacío = usa la tolerancia de Parámetros de asistencia.</mat-hint>
              <mat-error *ngIf="isFieldInvalid(form.get('minutosTolerancia'))">{{ mensajeToleranciaInvalida }}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
              <mat-label>Estatus</mat-label>
              <mat-select formControlName="estatus">
                <mat-option value="ACTIVO">Activo</mat-option>
                <mat-option value="INACTIVO">Inactivo</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </section>
      </div>

      <div class="col-12 col-lg-8">
        <section class="table-page__card horarios-editor-page__card">
          <div class="horarios-editor-page__section-head">
            <h2 class="horarios-editor-page__section-title">Configuración semanal</h2>
            <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="addDia()">
              <span class="material-icons">event_available</span>
              Agregar día
            </button>
          </div>

          <ng-container *ngIf="!loading; else editorLoadingState">
            <div formArrayName="dias" class="horarios-editor-page__days">
              <article class="horarios-editor-page__day" *ngFor="let dia of dias.controls; let i = index; trackBy: trackByIndex" [formGroupName]="i">
                <div class="horarios-editor-page__day-header">
                  <h3>Día laboral {{ i + 1 }}</h3>
                  <button type="button" class="table-page__action-btn table-page__action-btn--danger" title="Eliminar" aria-label="Eliminar" (click)="removeDia(i)" [disabled]="dias.length === 1">
                    <span class="material-icons">delete</span>
                  </button>
                </div>

                <div class="horarios-editor-page__day-grid">
                  <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
                    <mat-label>Día</mat-label>
                    <mat-select formControlName="diaSemana">
                      <mat-option *ngFor="let option of daysOfWeek" [value]="option.value">{{ option.label }}</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
                    <mat-label>Entrada</mat-label>
                    <input matInput type="time" formControlName="horaEntrada" aria-label="Entrada" />
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
                    <mat-label>Salida</mat-label>
                    <input matInput type="time" formControlName="horaSalida" aria-label="Salida" />
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
                    <mat-label>Minutos objetivo</mat-label>
                    <input matInput type="number" min="1" formControlName="minutosLaboralesObjetivo" aria-label="Minutos objetivo" />
                  </mat-form-field>
                </div>

                <div class="horarios-editor-page__meals">
                  <div class="horarios-editor-page__meals-header">
                    <strong>Bloques de comida</strong>
                    <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="addComida(i)">
                      <span class="material-icons">add_alarm</span>
                      Agregar comida
                    </button>
                  </div>

                  <div class="horarios-editor-page__meal-grid" formArrayName="bloquesComida">
                    <div class="horarios-editor-page__meal-row" *ngFor="let comida of bloquesComida(i).controls; let j = index; trackBy: trackByIndex" [formGroupName]="j">
                      <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
                        <mat-label>Inicio comida</mat-label>
                        <input matInput type="time" formControlName="horaInicio" aria-label="Inicio comida" />
                      </mat-form-field>

                      <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
                        <mat-label>Fin comida</mat-label>
                        <input matInput type="time" formControlName="horaFin" aria-label="Fin comida" />
                      </mat-form-field>

                      <button type="button" class="table-page__action-btn table-page__action-btn--danger" title="Quitar" aria-label="Quitar" (click)="removeComida(i, j)">
                        <span class="material-icons">remove_circle</span>
                      </button>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </ng-container>
        </section>
      </div>
    </form>
  </div>
</div>

<ng-template #editorLoadingState>
  <div class="table-page__empty table-page__empty--loading">
    <span class="material-icons">hourglass_top</span>
    <h3>Cargando horario</h3>
    <p>Espere un momento mientras se reconstruye la configuración semanal.</p>
  </div>
</ng-template>
